<template>
  <div class="project-edit">
    <el-card>
      <template slot="header">
        <span>{{isCreate ? '新增项目' : '项目详情'}}</span>
        <el-button v-if="!isCreate" type="primary" @click="editProject">{{canWrite ? '取消编辑' : '项目编辑'}}</el-button>
      </template>
    <el-form ref="form" :model="form" :rules="rules" v-loading="loading" label-width="auto">
      <!-- 基础信息 -->
      <p class="form-title first">基础信息</p>
      <el-form-item label="项目简称" prop="shortname">
        <el-input
          :disabled="!canWrite"
          v-model="form.shortname"
          maxlength="16"
          placeholder="请输入项目简称"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目全称" prop="fullname">
        <el-input
          :disabled="!canWrite"
          v-model="form.fullname"
          maxlength="16"
          placeholder="请输入项目全称"
        ></el-input>
      </el-form-item>

      <!-- 属性信息 -->
      <el-divider></el-divider>
      <p class="form-title">
        <span class="property-title">属性信息</span>
      </p>
      <el-form-item class="prop" label-width="0">
        <div
          v-show="canWrite ? true : hasTag(prop.propertycname)"
          class="prop-item"
          v-for="prop in propOptions"
          :key="prop.choice"
        >
          <span class="prop-title">{{prop.propertycname}}:</span>
          <p class="prop-tag">
            <template v-if="hasTag(prop.propertycname)">
              <el-tag
                v-for="(tag, tagIndex) in form.property.find(x => x.propertycname === prop.propertycname).list"
                type="info"
                :closable="canWrite"
                :key="tag.relateid"
                @close="deleteProp(tag.relateid, prop.propertycname, tagIndex)"
              >{{tag.propertyvalue}}</el-tag>
            </template>
          </p>
          <el-button
            v-if="canWrite"
            type="primary"
            size="mini"
            @click="propertyItem = {
              name: prop.propertycname,
              tagList: hasTag(prop.propertycname) ? form.property.find(x => x.propertycname === prop.propertycname).list : []
            }"
          >增加</el-button>
        </div>
      </el-form-item>

      <!-- 详情 -->
      <el-divider></el-divider>
      <p class="form-title">
        详情
        <el-button class="add-btn" size="mini" @click="editItem({})" type="primary" v-if="canWrite">新增</el-button>
      </p>
      <el-form-item label-width="0">
        <el-table
          :data="form.detail"
          style="width: 100%"
          row-key="detailid"
          :tree-props="{children: 'children'}"
         >

          <el-table-column
            prop="title"
            label="标题"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="context"
            label="内容"
            min-width="300"
          ></el-table-column>
          <el-table-column
            prop="time"
            label="时间"
            min-width="150"
          ></el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
          ></el-table-column>
          <el-table-column
            prop="uploadFile"
            label="文件"
            min-width="160"
          >
          <template v-slot="scope">
            <template v-if="scope.row.uploadFile && scope.row.uploadFile.length > 0">
              <div class="file-item" v-for="(item, index) in scope.row.uploadFile" :key='index'>
                <el-tooltip effect="dark" :content="item.filename" placement="top-start" >
                  <el-button size="mini" @click="viewfile(item)">文件{{index+1}}</el-button>
                </el-tooltip>
                <el-button size="mini" plain type="primary" @click="downfile(item)">下载</el-button>
              </div>
            </template>
          </template>
          </el-table-column>
          <el-table-column
            v-if="canWrite"
            label="操作"
            min-width="160"
            fixed="right"
          >
            <template v-slot="scope">
              <el-button @click="remove(scope.row, scope.$index)" size="mini">删除</el-button>
              <el-button @click="editItem(scope.row)" type="primary" size="mini">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item class="footer" v-if="canWrite">
        <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
        <el-button @click="$router.push('/project')">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
  <detail-edit v-model="detail"></detail-edit>
  <tag-edit v-model="propertyItem"></tag-edit>
  </div>
</template>

<script>
import http from '@/plugins/axios'
import detailEdit from './#detail-edit'
import tagEdit from './#tag-edit'
import * as utils from '@/utils'

export default {
  components: { detailEdit, tagEdit },
  props: {
  },
  data() {
    return {
      loading: false,
      isCreate: false,
      canWrite: false,
      propOptions: [],
      form: {
        shortname: '',
        fullname: '',
        detail: [],
        property: []
      },
      propertyItem: undefined,
      rules: {
        // project_name: {
        //   required: true,
        //   message: '请输入项目全称',
        //   trigger: 'change'
        // },
        // hangye: { required: true, message: '请选择行业' },
        // jiesuan_type: { required: true, message: '请选择结算类型' },
        // project_responsor: { required: true, message: '请选择项目负责人' },
        // project_status: { required: true, message: '请选择项目状态' },
        // sale_responsor: { required: true, message: '请选择销售负责人' },
        // responsor: { required: true, message: '请选择负责人' },
        // corp: { required: true, message: '请选择公司', trigger: 'change' }
      },
      detail: undefined
    }
  },
  created() {
    http.post('/allmessage/getchoice', { type: 'project' }).then(res => {
      this.propOptions = res.data.data
    })
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.id === undefined) {
      next(vm => {
        vm.isCreate = true
        vm.canWrite = true
      })
    } else {
      http.post('/allmessage/getj', {
        type: 'project',
        'id': to.query.id
      }).then(res => {
        next(vm => {
          vm.isCreate = false
          vm.canWrite = false
          vm.form = Object.assign(vm.form, res.data.data[0])
          // 因后台返回数据中同属性的分开的，所以需自己合并同属性名的值
          vm.form.property = utils.mergeArrObj(vm.form.property, 'propertycname')
          // 因为数据同标题的表格数据需要合并单行，所以对数据进行处理
          vm.form.detail = vm.form.detail.reduce((result, item) => {
            let repeatItem = result.find(x => x.title === item.title)
            if (repeatItem) {
              repeatItem.children ? repeatItem.children.push(item) : repeatItem.children = [item]
            } else {
              result.push(item)
            }
            return result
          }, [])
        })
      })
    }
  },
  methods: {
    hasTag(propname) {
      if (this.form.property.find(x => x.propertycname === propname)) {
        return this.form.property.find(x => x.propertycname === propname).list.length > 0
      } else {
        return false
      }
    },
    editProject() {
      this.canWrite = !this.canWrite
    },
    deleteProp(id, propname, tagIndex) {
      http.post('/allmessage/deleterelatej  ', { type: 'project', id: id }).then(res => {
        const propIndex = this.form.property.findIndex(x => x.propertycname === propname)
        this.form.property[propIndex].list.splice(tagIndex, 1)
      })
    },
    editItem(val) {
      this.detail = val
    },
    viewfile(item) {
      this.$notify.success({
        title: '预览',
        message: item.filename
      })
      http.get(`/allmessage/viewfile?id=${item.fileid}`, {
        responseType: 'blob'
      }).then(res => {
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(res.data)
        link.target = '_blank'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    downfile(item) {
      this.$notify.success({
        title: '正在下载...',
        message: item.filename
      })
      http.get(`/allmessage/downfile?id=${item.fileid}`, {
        responseType: 'blob'
      }).then(res => {
        console.log(res)
        let link = document.createElement('a')
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', false, false)
        link.href = URL.createObjectURL(res.data)
        link.download = item.path
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    remove(item, index) {
      http.post('/allmessage/deletedetailj', { type: 'project', id: item.detailid }).then(res => {
        if (res.data.delete === 1) {
          this.$message.success('删除成功')
          this.reload('detail')
        }
      })
    },
    reload(part) {
      http.post('/allmessage/getj', {
        type: 'project',
        'id': this.$route.query.id
      }).then(res => {
        if (part === 'property') {
          // 属性信息更新
          // 因后台返回数据中同属性的分开的，所以需自己合并同属性名的值
          this.form.property = utils.mergeArrObj(res.data.data[0].property, 'propertycname')
        } else {
          // 详情更新
          this.form.detail = res.data.data[0].detail.reduce((result, item) => {
            let repeatItem = result.find(x => x.title === item.title)
            if (repeatItem) {
              repeatItem.children ? repeatItem.children.push(item) : repeatItem.children = [item]
            } else {
              result.push(item)
            }
            return result
          }, [])
        }
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          // 基本信息
          http.post('/allmessage/addj', {
            id: this.$route.query.id,
            type: 'project',
            fullname: this.form.fullname,
            shortname: this.form.shortname
          }).then(res => {
            this.loading = false
            this.$router.go(-1)
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.project-edit {
  .el-card {
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px;
    }
    &__body {
      padding: 20px 30px;
    }
  }
  .el-form {
    .form-title {
      min-width: 300px;
      margin-bottom: 30px;
      font-size: 15px;
      .property-title {
        margin-right: 64px;
      }
      .add-btn {
        width: 70px;
        float: right;
      }
      &.first {
        margin-top: 0;
      }
    }
    .prop {
      .prop-item {
        display: flex;
        margin-bottom: 4px;
        .prop-title {
          display: inline-block;
          min-width: 120px;
        }
        .prop-tag {
          min-width: 600px;
          .el-tag {
            margin-right: 12px;
          }
        }
      }
    }
    .file-item {
      .el-button {
        margin: 0 4px 4px;
      }
    }
    .footer {
      text-align: center;
      margin-top: 48px;
      .el-button {
        width: 80px;
      }
    }
  }
  .el-divider { background: #eee;}
}
</style>
